import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { api } from "../utils/Api";
import {
	Typography,
	Flex,
	Row,
	Col,
	Select,
	Statistic,
	Table,
	Modal,
	Tabs,
	notification,
	Button,
} from "antd";
import Layout from "../layout/Layout";
import { CustomSpinner } from "../utils/CustomComponents";
import { franchiseOptions } from "../../constants/Customer";
import FranchiseSellerYardsPerPsi from "./FranchiseSellerYardsPerPsi";
import FranchiseMaterials from "./FranchiseMaterials";
import FranchiseSellerMonthMaterial from "./FranchiseSellerMonthMaterial";
import FranchiseSellerMonthWeek from "./FranchiseSellerMonthWeek";
import FranchiseSellerMonthDays from "./FranchiseSellerMonthDays";
import { CSVLink } from "react-csv";
const { Text, Title } = Typography;

const FranchiseDashboard = () => {
	const [loading, setLoading] = useState(true);
	const [loadingTable, setLoadingTable] = useState(true);
	const [franchise, setFranchise] = useState("57Concrete");
	const [jobList, setJobList] = useState([]);
	const [disabled, setDisabled] = useState(true);
	const [modalSellerOpen, setModalSellerOpen] = useState(false);
	const [modalFranchiseOpen, setModalFranchiseOpen] = useState(false);
	const [modalSellerMonthOpen, setModalSellerMonthOpen] = useState(false);
	const [plantList, setPlantList] = useState([]);
	const [plant, setPlant] = useState("All");
	const sellerId = useRef(null);
	const month = useRef(null);
	const refDownload = useRef();

	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Seller",
			dataIndex: "seller",
			key: "seller",
			render: (value, values) => {
				return (
					<Text
						onClick={() => {
							sellerId.current = values.sellerId;
							setModalSellerOpen(true);
						}}
						style={{ cursor: "pointer" }}
					>
						{value}
					</Text>
				);
			},
		},
		{
			title: "Jan",
			dataIndex: "1",
			key: "1",
			render: (value, values) => {
				return (
					<div
						onClick={
							value
								? () => {
										sellerId.current = values.sellerId;
										month.current = "1";
										setModalSellerMonthOpen(true);
								  }
								: null
						}
						style={{ cursor: value ? "pointer" : "default" }}
					>
						<Statistic
							value={value}
							valueStyle={{
								fontSize: 14,
							}}
							suffix={value ? "yards" : ""}
						/>
					</div>
				);
			},
		},
		{
			title: "Feb",
			dataIndex: "2",
			key: "2",
			render: (value, values) => {
				return (
					<div
						onClick={
							value
								? () => {
										sellerId.current = values.sellerId;
										month.current = "2";
										setModalSellerMonthOpen(true);
								  }
								: null
						}
						style={{ cursor: value ? "pointer" : "default" }}
					>
						<Statistic
							value={value}
							valueStyle={{
								fontSize: 14,
							}}
							suffix={value ? "yards" : ""}
						/>
					</div>
				);
			},
		},
		{
			title: "Mar",
			dataIndex: "3",
			key: "3",
			render: (value, values) => {
				return (
					<div
						onClick={
							value
								? () => {
										sellerId.current = values.sellerId;
										month.current = "3";
										setModalSellerMonthOpen(true);
								  }
								: null
						}
						style={{ cursor: value ? "pointer" : "default" }}
					>
						<Statistic
							value={value}
							valueStyle={{
								fontSize: 14,
							}}
							suffix={value ? "yards" : ""}
						/>
					</div>
				);
			},
		},
		{
			title: "Apr",
			dataIndex: "4",
			key: "4",
			render: (value, values) => {
				return (
					<div
						onClick={
							value
								? () => {
										sellerId.current = values.sellerId;
										month.current = "4";
										setModalSellerMonthOpen(true);
								  }
								: null
						}
						style={{ cursor: value ? "pointer" : "default" }}
					>
						<Statistic
							value={value}
							valueStyle={{
								fontSize: 14,
							}}
							suffix={value ? "yards" : ""}
						/>
					</div>
				);
			},
		},
		{
			title: "May",
			dataIndex: "5",
			key: "5",
			render: (value, values) => {
				return (
					<div
						onClick={
							value
								? () => {
										sellerId.current = values.sellerId;
										month.current = "5";
										setModalSellerMonthOpen(true);
								  }
								: null
						}
						style={{ cursor: value ? "pointer" : "default" }}
					>
						<Statistic
							value={value}
							valueStyle={{
								fontSize: 14,
							}}
							suffix={value ? "yards" : ""}
						/>
					</div>
				);
			},
		},
		{
			title: "Jun",
			dataIndex: "6",
			key: "6",
			render: (value, values) => {
				return (
					<div
						onClick={
							value
								? () => {
										sellerId.current = values.sellerId;
										month.current = "6";
										setModalSellerMonthOpen(true);
								  }
								: null
						}
						style={{ cursor: value ? "pointer" : "default" }}
					>
						<Statistic
							value={value}
							valueStyle={{
								fontSize: 14,
							}}
							suffix={value ? "yards" : ""}
						/>
					</div>
				);
			},
		},
		{
			title: "Jul",
			dataIndex: "7",
			key: "7",
			render: (value, values) => {
				return (
					<div
						onClick={
							value
								? () => {
										sellerId.current = values.sellerId;
										month.current = "7";
										setModalSellerMonthOpen(true);
								  }
								: null
						}
						style={{ cursor: value ? "pointer" : "default" }}
					>
						<Statistic
							value={value}
							valueStyle={{
								fontSize: 14,
							}}
							suffix={value ? "yards" : ""}
						/>
					</div>
				);
			},
		},
		{
			title: "Aug",
			dataIndex: "8",
			key: "8",
			render: (value, values) => {
				return (
					<div
						onClick={
							value
								? () => {
										sellerId.current = values.sellerId;
										month.current = "8";
										setModalSellerMonthOpen(true);
								  }
								: null
						}
						style={{ cursor: value ? "pointer" : "default" }}
					>
						<Statistic
							value={value}
							valueStyle={{
								fontSize: 14,
							}}
							suffix={value ? "yards" : ""}
						/>
					</div>
				);
			},
		},
		{
			title: "Sep",
			dataIndex: "9",
			key: "9",
			render: (value, values) => {
				return (
					<div
						onClick={
							value
								? () => {
										sellerId.current = values.sellerId;
										month.current = "9";
										setModalSellerMonthOpen(true);
								  }
								: null
						}
						style={{ cursor: value ? "pointer" : "default" }}
					>
						<Statistic
							value={value}
							valueStyle={{
								fontSize: 14,
							}}
							suffix={value ? "yards" : ""}
						/>
					</div>
				);
			},
		},
		{
			title: "Oct",
			dataIndex: "10",
			key: "10",
			render: (value, values) => {
				return (
					<div
						onClick={
							value
								? () => {
										sellerId.current = values.sellerId;
										month.current = "10";
										setModalSellerMonthOpen(true);
								  }
								: null
						}
						style={{ cursor: value ? "pointer" : "default" }}
					>
						<Statistic
							value={value}
							valueStyle={{
								fontSize: 14,
							}}
							suffix={value ? "yards" : ""}
						/>
					</div>
				);
			},
		},
		{
			title: "Nov",
			dataIndex: "11",
			key: "11",
			render: (value, values) => {
				return (
					<div
						onClick={
							value
								? () => {
										sellerId.current = values.sellerId;
										month.current = "11";
										setModalSellerMonthOpen(true);
								  }
								: null
						}
						style={{ cursor: value ? "pointer" : "default" }}
					>
						<Statistic
							value={value}
							valueStyle={{
								fontSize: 14,
							}}
							suffix={value ? "yards" : ""}
						/>
					</div>
				);
			},
		},
		{
			title: "Dec",
			dataIndex: "12",
			key: "12",
			render: (value, values) => {
				return (
					<div
						onClick={
							value
								? () => {
										sellerId.current = values.sellerId;
										month.current = "12";
										setModalSellerMonthOpen(true);
								  }
								: null
						}
						style={{ cursor: value ? "pointer" : "default" }}
					>
						<Statistic
							value={value}
							valueStyle={{
								fontSize: 14,
							}}
							suffix={value ? "yards" : ""}
						/>
					</div>
				);
			},
		},
	];

	useEffect(() => {
		if (franchise && plant) {
			getJobs();
		}
	}, [franchise, plant]);

	useEffect(() => {
		getPlants();
	}, []);

	const getJobs = async () => {
		try {
			setLoading(true);
			setDisabled(true);

			const url = api + `/job/seller/yards/${franchise}/${plant}`;

			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);

			const groupedSellers = data.payload.reduce((acc, item) => {
				if (!acc[item.sellerName]) {
					acc[item.sellerName] = [];
				}
				acc[item.sellerName].push(item);
				return acc;
			}, {});

			const newRows = Object.entries(groupedSellers).map(([key, values]) => {
				let obj = {
					seller: key,
					sellerId: values[0].seller,
				};

				values.map((item) => {
					obj[`${item.month}`] = item.totalYards;
				});

				return obj;
			});

			setJobList(newRows);
			setLoading(false);
			setDisabled(false);
			setLoadingTable(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getPlants = async () => {
		const url = api + "/plant/list/57Concrete";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [
					{
						value: "All",
						label: "All",
					},
				];
				data.payload
					.filter((i) => i.name !== "Laredo")
					.map((item) => {
						list.push({
							value: item._id,
							label: item.name,
						});
					});
				setPlantList(list);
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			openNotification("error", "Error", err.message);
			console.error(err.message);
			return null;
		}
	};

	const onChangeFranchise = (value) => {
		setFranchise(value);
	};

	const onChangePlant = (value) => {
		setPlant(value);
	};

	const RenderModalSeller = () => {
		return (
			<Modal
				title="Seller Yards By Psi"
				open={modalSellerOpen}
				onCancel={() => setModalSellerOpen(false)}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={1200}
			>
				<FranchiseSellerYardsPerPsi sellerId={sellerId.current} plant={plant} />
			</Modal>
		);
	};

	const RenderModalFranchise = () => {
		return (
			<Modal
				title="Franchise Materials"
				open={modalFranchiseOpen}
				onCancel={() => setModalFranchiseOpen(false)}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={1200}
			>
				<FranchiseMaterials franchise={franchise} plant={plant} />
			</Modal>
		);
	};

	const getMonth = (month) => {
		let monthName = "";
		switch (month) {
			case "1":
				monthName = "January";
				break;
			case "2":
				monthName = "February";
				break;
			case "3":
				monthName = "March";
				break;
			case "4":
				monthName = "April";
				break;
			case "5":
				monthName = "May";
				break;
			case "6":
				monthName = "June";
				break;
			case "7":
				monthName = "July";
				break;
			case "8":
				monthName = "August";
				break;
			case "9":
				monthName = "September";
				break;
			case "10":
				monthName = "October";
				break;
			case "11":
				monthName = "November";
				break;
			case "12":
				monthName = "December";
				break;
			default:
				monthName = "Invalid";
				break;
		}
		return monthName;
	};

	const RenderModalSellerMonthMaterial = () => {
		let currentTab = "material";
		const items = [
			{
				key: "material",
				label: "Seller Month Materials",
				children: (
					<FranchiseSellerMonthMaterial
						sellerId={sellerId.current}
						month={month.current}
						plant={plant}
					/>
				),
			},
			{
				key: "weeks",
				label: "Weeks",
				children: (
					<FranchiseSellerMonthWeek
						sellerId={sellerId.current}
						month={month.current}
						plant={plant}
					/>
				),
			},
			{
				key: "days",
				label: "Days",
				children: (
					<FranchiseSellerMonthDays
						sellerId={sellerId.current}
						month={month.current}
						plant={plant}
					/>
				),
			},
		];

		const onChange = (key) => {
			currentTab = key;
		};

		return (
			<Modal
				title={`Month ${getMonth(month.current)}`}
				open={modalSellerMonthOpen}
				onCancel={() => setModalSellerMonthOpen(false)}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={800}
			>
				<Tabs defaultActiveKey={currentTab} items={items} onChange={onChange} />
			</Modal>
		);
	};

	const RenderHeader = () => {
		return (
			<Row gutter={[16, 32]}>
				<Col span={6}>
					<Select
						size="large"
						options={franchiseOptions}
						value={franchise}
						onChange={onChangeFranchise}
						style={{ width: "100%" }}
						loading={disabled}
						disabled={disabled}
					/>
				</Col>
				<Col span={6}>
					<Select
						size="large"
						options={plantList}
						value={plant}
						onChange={onChangePlant}
						style={{ width: "100%" }}
						loading={disabled}
						disabled={disabled}
					/>
				</Col>
				{!loading && (
					<Col span={24}>
						<Title
							level={4}
							onClick={() => setModalFranchiseOpen(true)}
							style={{ cursor: "pointer" }}
						>
							Franchise {franchise}
						</Title>
					</Col>
				)}
			</Row>
		);
	};

	const headers = () => {
		return columns.map((item) => {
			return {
				key: item.key,
				label: item.title,
			};
		});
	};

	const RenderDownloadReport = () => {
		return (
			<div>
				<CSVLink
					data={jobList}
					headers={headers()}
					filename={"57concrete-franchise-yards.csv"}
					hidden
					ref={refDownload}
				>
					Download report
				</CSVLink>
				<Row gutter={16}>
					<Col span={24}>
						<Button
							type="primary"
							style={{ width: "100%" }}
							onClick={(e) => refDownload.current.link.click()}
							loading={loading}
							size="large"
						>
							Download Report
						</Button>
					</Col>
				</Row>
			</div>
		);
	};

	const RenderTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				<Table
					columns={columns}
					dataSource={jobList}
					loading={loadingTable}
					pagination={false}
				/>
			</Flex>
		);
	};

	return (
		<Layout title="Franchises Report" description="Franchises Yards">
			<Flex vertical gap={"large"}>
				<RenderHeader />
				<RenderDownloadReport />
				{loading ? <CustomSpinner /> : <RenderTable />}
				<RenderModalSeller />
				<RenderModalFranchise />
				<RenderModalSellerMonthMaterial />
				{contextHolder}
			</Flex>
		</Layout>
	);
};

export default FranchiseDashboard;
